module.exports = __webpack_public_path__ + "img/IMG_2254_L_Black.f8d6dddd.jpg";